/**
 * NOS-153: Curated builder font list + heading/body pairing presets for the
 * Brand panel (spec: docs/specs/BUILDER_BEST_IN_CLASS.md §A1).
 *
 * Every family here is a Google Font loadable through the existing
 * loadFont()/useSiteStyles() path in src/hooks/useGoogleFont.ts.
 */

export interface BuilderFont {
  name: string
  value: string
}

/**
 * BUILDER_DESIGN_SPEC.md Section 12 fonts, plus NOS-153 additions
 * (Lora, Work Sans, Space Grotesk, Merriweather).
 */
export const BUILDER_FONTS: BuilderFont[] = [
  { name: "DM Sans", value: "DM Sans, sans-serif" },
  { name: "Source Serif 4", value: "Source Serif 4, serif" },
  { name: "Outfit", value: "Outfit, sans-serif" },
  { name: "Fraunces", value: "Fraunces, serif" },
  { name: "Libre Franklin", value: "Libre Franklin, sans-serif" },
  { name: "Playfair Display", value: "Playfair Display, serif" },
  { name: "Inter", value: "Inter, sans-serif" }, // fallback for existing orgs
  { name: "Lora", value: "Lora, serif" },
  { name: "Work Sans", value: "Work Sans, sans-serif" },
  { name: "Space Grotesk", value: "Space Grotesk, sans-serif" },
  { name: "Merriweather", value: "Merriweather, serif" },
]

export interface TypePairing {
  name: string
  heading: string
  body: string
}

/** Curated heading/body pairings shown as one-click presets in the Brand panel. */
export const TYPE_PAIRINGS: TypePairing[] = [
  { name: "Modern", heading: "Space Grotesk, sans-serif", body: "Work Sans, sans-serif" },
  { name: "Editorial", heading: "Playfair Display, serif", body: "Source Serif 4, serif" },
  { name: "Friendly", heading: "DM Sans, sans-serif", body: "DM Sans, sans-serif" },
  { name: "Classic", heading: "Merriweather, serif", body: "Libre Franklin, sans-serif" },
  { name: "Warm", heading: "Fraunces, serif", body: "Lora, serif" },
  { name: "Clean", heading: "Outfit, sans-serif", body: "Inter, sans-serif" },
]
